"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetrcCategory = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const enums_1 = require("./enums");
let MetrcCategory = class MetrcCategory {
};
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], MetrcCategory.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)(),
    tslib_1.__metadata("design:type", String)
], MetrcCategory.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "enum", enum: enums_1.ProductType }),
    (0, typeorm_1.Index)(),
    tslib_1.__metadata("design:type", String)
], MetrcCategory.prototype, "type", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "enum", enum: enums_1.UnitType }),
    tslib_1.__metadata("design:type", String)
], MetrcCategory.prototype, "unit", void 0);
MetrcCategory = tslib_1.__decorate([
    (0, typeorm_1.Entity)()
], MetrcCategory);
exports.MetrcCategory = MetrcCategory;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0cmNDYXRlZ29yeS5qcyIsInNvdXJjZVJvb3QiOiIuL3NyYy8iLCJzb3VyY2VzIjpbInBhY2thZ2VzL21vZGVscy9zcmMvbWV0cmNDYXRlZ29yeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEscUNBQXdFO0FBQ3hFLG1DQUFnRDtBQUd6QyxJQUFNLGFBQWEsR0FBbkIsTUFBTSxhQUFhO0NBVXpCLENBQUE7QUFURztJQUFDLElBQUEsZ0NBQXNCLEdBQUU7O3lDQUNkO0FBQ1g7SUFBQyxJQUFBLGdCQUFNLEdBQUU7OzJDQUNJO0FBQ2I7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLElBQUksRUFBRSxtQkFBVyxFQUFFLENBQUM7SUFDM0MsSUFBQSxlQUFLLEdBQUU7OzJDQUNVO0FBQ2xCO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsZ0JBQVEsRUFBRSxDQUFDOzsyQ0FDMUI7QUFUTixhQUFhO0lBRHpCLElBQUEsZ0JBQU0sR0FBRTtHQUNJLGFBQWEsQ0FVekI7QUFWWSxzQ0FBYSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbHVtbiwgRW50aXR5LCBJbmRleCwgUHJpbWFyeUdlbmVyYXRlZENvbHVtbiB9IGZyb20gXCJ0eXBlb3JtXCI7XG5pbXBvcnQgeyBQcm9kdWN0VHlwZSwgVW5pdFR5cGUgfSBmcm9tIFwiLi9lbnVtc1wiO1xuXG5ARW50aXR5KClcbmV4cG9ydCBjbGFzcyBNZXRyY0NhdGVnb3J5IHtcbiAgICBAUHJpbWFyeUdlbmVyYXRlZENvbHVtbigpXG4gICAgaWQ6IG51bWJlcjtcbiAgICBAQ29sdW1uKClcbiAgICBuYW1lOiBzdHJpbmc7XG4gICAgQENvbHVtbih7IHR5cGU6IFwiZW51bVwiLCBlbnVtOiBQcm9kdWN0VHlwZSB9KVxuICAgIEBJbmRleCgpXG4gICAgdHlwZTogUHJvZHVjdFR5cGU7XG4gICAgQENvbHVtbih7IHR5cGU6IFwiZW51bVwiLCBlbnVtOiBVbml0VHlwZSB9KVxuICAgIHVuaXQ6IFVuaXRUeXBlO1xufSJdfQ==